import { xray } from 'lib/xray';
import { IPromoSecondClick } from 'reactApp/modules/promo/promo.types';
import { TipContent } from 'reactApp/ui/Datalist/Item/TipContent';

interface ITip {
    id: string;
    getTipContent: typeof TipContent;
    onHideClick: () => void;
}

function promoToTip(promo: IPromoSecondClick): ITip[] | null {
    return [
        {
            id: promo.promoId,
            getTipContent: TipContent,
            onHideClick: () => promo.onClose(),
        },
    ];
}

export const getSelectedCount = (key: string, columnCount: number): number => {
    switch (key) {
        case 'ArrowDown':
            return columnCount;
        case 'ArrowUp':
            return -columnCount;
        case 'ArrowLeft':
            return -1;
        case 'ArrowRight':
            return 1;
        default:
            return 0;
    }
};

export const logHandler = ({ radars, radarName }: { radars?: string[]; radarName: string }): void => {
    if (radars) {
        for (const element of radars) {
            const r = element.split('=');

            xray.send('datalist', {
                i: {
                    [`${radarName}_${r[0]}`]: Number(r[1]),
                },
            });
        }
    } else {
        xray.send(`datalist_${radarName}`);
    }
};

interface IProps {
    selectedCount: number;
    isDragging: boolean;
    disableTips: boolean;
    promo?: IPromoSecondClick;
}

export const getShowSecondClickTip = ({ selectedCount, isDragging, disableTips, promo }: IProps) => {
    if (!promo || isDragging || disableTips || !(selectedCount > 0)) {
        return null;
    }

    return promoToTip(promo) || null;
};
